type SusyTabItemProps = {
    onClick: (currentTab: string) => void;
    tabHeader: string;
    tabName?: string;
    tabLocalization: string;
    selectedTabName: string;
    isSubTab: boolean;
    isTabActive?: boolean;
};

export const SusyTabItem = ({
    onClick,
    tabName,
    tabHeader,
    tabLocalization,
    selectedTabName,
    isSubTab,
    isTabActive,
}: SusyTabItemProps) => {
    const onClickTab = (currentTab: string) => {
        onClick(currentTab);
    };

    const getCSSClassName = () => {
        const baseName = isSubTab ? 'susy-sub-tabs-item' : 'susy-tabs-item';
        const isActive =
            isTabActive ?? selectedTabName === (tabName ?? tabHeader)
                ? 'active'
                : '';
        return `${baseName} ${isActive}`;
    };

    return (
        <div
            className={getCSSClassName()}
            onClick={() => {
                onClickTab(tabName ?? tabHeader);
            }}
        >
            {tabLocalization}
        </div>
    );
};
